// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f984a6a4","455":"026c4ec7","946":"5c0b87d7"}[chunkId] + ".chunk.js";
};